export enum DocumentCheckinType {
	NoDocument = 0,
	Uploaded = 1,
	CheckedIn = 2,
	CheckedOut = 3,
	Published = 4,
	PreviousData = 5
}